import React from "react";
import { Link } from "react-router-dom";

function EmailVerify() {
  return (
    <section class="bg-white dark:bg-gray-800">
      <div class="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
        <div class="mx-auto max-w-screen-sm text-center">
          <h1 class="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl  dark:text-slate-100">
            Is that really you!!
          </h1>
          <p class="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
            Verify your E-mail to make sure
          </p>
          <p class="mb-4 text-lg font-light  dark:text-gray-400">
            Go on to your mail and click on Verify to gain access to this
            wonderful Website Cutie :)
          </p>
          <Link
            to="/"
            class="inline-flex bg-primary-600 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:text-slate-100 dark:focus:ring-primary-900 my-4"
          >
            Back to Homepage
          </Link>
        </div>
      </div>
    </section>
  );
}

export default EmailVerify;
